export default class TrackerHelperFragment {

  getInfo() {
    return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}');
  }

  setInfo(value) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      ...(JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}')),
      ...value,
    }));
  }

  clearInfo() {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  setInState(key, value) {
    this.state[key] = value;
  }

  getFromState(key) {
    return this.state[key];
  }

  deleteFromState(key) {
    delete this.state[key];
  }

  clearState() {
    self.state = {};
  }
}
